import * as React from "react";

import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";

import { ActionProps } from "./ActionProps";

export const useActionClickHandler = (props: ActionProps) => {
    const track = useMetrics();
    return React.useCallback(
        (e: React.SyntheticEvent<HTMLElement>) => {
            if (props.metricName != undefined) {
                track(
                    props.metricName,
                    isNotNullOrUndefined(props.bindingPath) ? { bindingPath: props.bindingPath } : undefined
                );
            }
            props.onClick(e);
        },
        [props.metricName, props.bindingPath]
    );
};
